import normalizeJsonApi from '../../shared/utilities/jsonApiNormalizer';
import { JsonApiObject } from '../../shared/utilities/jsonApiNormalizer';

import { Testimonial, TestimonialJSONAPIResponse } from './types';

export function serializeTestimonialFromAPI(json: TestimonialJSONAPIResponse): Testimonial {
    const { testimonial } = normalizeJsonApi<{
        testimonial: Record<string, JsonApiObject>;
    }>(json);
    const dossierId = json.data.id;

    return testimonial[dossierId].attributes as Testimonial;
}
